import { Box, Typography } from "@mui/material";
import React from "react";

export default function ItemCard({ itemBankAccount, title }) {
  return (
    <Box display="flex" justifyContent=" space-between" my={2}>
      <Typography variant="h6" color="common.white">
        {itemBankAccount}
      </Typography>
      <Typography variant="h6" color="common.white">
        {title}
      </Typography>
    </Box>
  );
}
